var PrintSettings = /** @class */ (function () {
    function PrintSettings() {
        this.showTherapistNotes = false;
    }
    Object.defineProperty(PrintSettings.prototype, "showTherapistNotes", {
        get: function () {
            return this._showTherapistNotes;
        },
        set: function (value) {
            this._showTherapistNotes = value;
        },
        enumerable: true,
        configurable: true
    });
    return PrintSettings;
}());
export { PrintSettings };



// WEBPACK FOOTER //
// ./src/app/reports/models/print-settings.ts.pre-build-optimizer.js